import { render, staticRenderFns } from "./healthInsCheckAccount.vue?vue&type=template&id=b105d2d0&scoped=true&"
import script from "./healthInsCheckAccount.vue?vue&type=script&lang=js&"
export * from "./healthInsCheckAccount.vue?vue&type=script&lang=js&"
import style0 from "./healthInsCheckAccount.vue?vue&type=style&index=0&id=b105d2d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b105d2d0",
  null
  
)

export default component.exports